import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=540f2cdd&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=540f2cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f2cdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540f2cdd')) {
      api.createRecord('540f2cdd', component.options)
    } else {
      api.reload('540f2cdd', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=540f2cdd&scoped=true&", function () {
      api.rerender('540f2cdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QnAeRhqHcRlA/JS/comp/Voucher.vue"
export default component.exports